var map = {
	"./comments": 7774,
	"./comments.json": 7774,
	"./items": 1124,
	"./items.json": 1124,
	"./links": 6653,
	"./links.json": 6653,
	"./origin": 3430,
	"./origin.json": 3430,
	"./tmdb_logo.svg": 9292
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5187;